if (!customElements.get('product-multi-add')) {
  customElements.define('product-multi-add', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const mutipleProdData = [];
      const timestamp = Math.round(new Date().getTime()/1000);
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Re-read restored inputs before building the cart payload, not stale DOM data.
      if (typeof syncConfiguratorFinishFromInputs === 'function' && !syncConfiguratorFinishFromInputs()) {
        this.handleErrorMessage(window.variantStrings.unavailable);
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      /* ***Additional products object*** */
      let additionalProductsEle = document.querySelector('.config-main-product [data-additional-product-id]:not(:disabled):checked');
      let additionalPdPrice;
      if(document.querySelector('[data-additional-prod-price]')){
        additionalPdPrice = document.querySelector('[data-additional-prod-price]').getAttribute('data-additional-prod-price');
      }
      if(additionalProductsEle){
        //mutipleProdData.push({id: parseInt(additionalProductsEle.dataset.additionalProductId), quantity:1, properties:{"_timestampID": timestamp, "_price": additionalPdPrice }});
        mutipleProdData.push({id: parseInt(additionalProductsEle.dataset.additionalProductId), quantity:1, properties:{"_price": additionalPdPrice }});
      }

      /* ***Main products object*** */
      if(this.form.querySelector('[name=id]')){
        let selected_variant_title, selectedDimension;
        const configEle = document.querySelector(`.config-main-product [data-item-config]`);
        if(!configEle) return;

        const inputConfigEle = JSON.parse(configEle.dataset.itemConfig);
        selected_variant_title = configEle.dataset.selectedOptionTitle;

        const dataInputValues = [];

        for (let key in inputConfigEle) {
          let item = inputConfigEle[key];
          const itemInput = item["item-inputs"];
          const itemPrice = item["item-price"];
          const itemSKU = item["item-sku"];
         const index = Number(key.split('-')[1]) - 1;
          console.log("item",index);
          const skuInput = document.querySelector('input[name="properties[_original_sku]"]');
          let skuValue = skuInput ? skuInput.value : null;
          // Massstabsgetreu (06.10.2026): Druck-App soll die 117-cm-Vorlage nehmen
          const tsImg = document.querySelector('.source-image');
          const tsCm = tsImg ? (parseFloat(tsImg.dataset.trueScaleCm) || 0) : 0;
          if (skuValue && tsCm > 0) skuValue = skuValue.replace(/_\d+$/, '_' + Math.round(tsCm));
          const loopimage = document.querySelector('input[name="properties[_number_of_loop_image]"]');
          const loopimageValue = loopimage ? loopimage.value : null;
          const getProp = (name) => {
            return document.querySelector(`input[name="properties[${name}_${index}]"]`)?.value || null;
          };

          if (itemInput && itemPrice && itemSKU) {
            mutipleProdData.push({
              id: parseInt(this.form.querySelector('[name=id]').value),
              quantity: 1,
              properties: {
                "_frontend_width":  getProp("_frontend_width"),
                "_frontend_height": getProp("_frontend_height"),
                "_print_width_cm":  getProp("_print_width_cm"),
                "_print_height_cm": getProp("_print_height_cm"),
                "_crop_width":      getProp("_crop_width"),
                "_crop_height":     getProp("_crop_height"),
                "_crop_x":          getProp("_crop_x"),
                "_crop_y":          getProp("_crop_y"),
                "_number_of_loop_image": loopimageValue,
                "_original_sku":    skuValue,
                "_price":           itemPrice,
                "Maß":              itemInput,
                "_Ausführung":      selected_variant_title,
                "_SKU":             itemSKU,
                "_customise_product": true
              }
            });
          }
        }
        
      }

      // **AddToCart All Selcted Products** *//
      const CART_SECTION = this.cart.getSectionsToRender().map((section) => section.id);
      const ADDTOCART_OBJECT = { items: mutipleProdData, sections: CART_SECTION, sections_url: window.location.pathname };
      //console.log('ADDTOCART_OBJECT -->', ADDTOCART_OBJECT);

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(ADDTOCART_OBJECT)
      })
      .then(response => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => { this.cart.renderContents(response) });
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally((e) => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
